import type { NSendoutsApi } from '@app/services/rtkQuery/Sendouts/types';

export type SendoutStatusEvent = Pick<NSendoutsApi.Sendout, 'Id' | 'Status'>;

/**
 * Разбирает payload WS-события о смене статуса рассылки. Сейчас бэкенд шлёт
 * модель в camelCase ({ id, status }), но на случай перехода на обёртку
 * { jsonData: string } или PascalCase поддерживаем и эти варианты.
 */
export const parseSendoutStatusEvent = (
  raw: unknown
): SendoutStatusEvent | null => {
  let payload: unknown = raw;

  if (payload && typeof payload === 'object' && 'jsonData' in payload) {
    payload = (payload as { jsonData: unknown }).jsonData;
  }

  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload);
    } catch {
      return null;
    }
  }

  if (!payload || typeof payload !== 'object') return null;

  const model = payload as Record<string, unknown>;
  const Id = model.Id ?? model.id;
  const Status = model.Status ?? model.status;

  return typeof Id === 'number' && typeof Status === 'string'
    ? { Id, Status }
    : null;
};
